
























































import { Vue, Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { BreadCrumbElement } from '@/models/bread-crumb-element';
import { GEnum } from '@/constants/enum.defination';
import { CompetencyDistributionEchartService } from '@/service/echart/competency-distribution.echart.service';
import { studentAllCompetencyModule } from '@/store/modules/frames/student-all-competency.module';
import { studentModule } from '@/store/modules/entities/student.module';
import { Constants } from '@/constants/constants';
import { StudentCompetencyDistribution } from '@/models/student/student-competency-data';
import { Student } from '@/models/student/student';
import { PagingData } from '@/models/core/paging-data';
import { CompetencyDistributionRequest } from '@/models/competency/competency-distribution-request';
import GCompetencyLabel from '@/components/GCompetencyLabel.vue';
import GLoading from '@/components/GLoading.vue';
import GStudentRecordScoreComparison from '@/views/GStudentRecord/GStudentRecordScoreComparison.vue';
import { GPageBase } from '@/mixins';

@Component({
  name: 'GStudentAllCompetencyDistribution',
  components: { GStudentRecordScoreComparison, GLoading, GCompetencyLabel },
  computed: {},
  methods: {},
})
export default class GStudentAllCompetencyDistribution extends Mixins(GPageBase) {
  breadCrumbItems: BreadCrumbElement[] = [];
  scaleType: GEnum.ScaleType = GEnum.ScaleType.SchoolClass;
  lazy: boolean = true;
  targetType: GEnum.TargetType = GEnum.TargetType.Class;
  targetID: number = 0;
  competencyDistributionCharts: CompetencyDistributionEchartService[] = [];
  readonly CHART_HEIGHT = 180;

  async mounted() {
    if (this.studentCompetencyDistributions.length > 0) {
      this.updateChart();
    }
  }

  @Watch('studentCompetencyDistributions')
  watchStudentCompetencyDistributions(value: StudentCompetencyDistribution[]) {
    if (value.length > 0) {
      this.updateChart();
    }
  }

  get competencyIDs(): number[] {
    return Constants.CompetencyIDsBySortedType;
  }

  get studentCompetencyDistributions(): StudentCompetencyDistribution[] {
    return studentAllCompetencyModule.studentCompetencyDistributions;
  }

  get student(): Student {
    return studentModule.student;
  }

  get students(): PagingData<Student> {
    return studentModule.students;
  }

  get scaleTypeGrade(): GEnum.ScaleType {
    return GEnum.ScaleType.Grade;
  }

  get scaleTypeSchoolClass(): GEnum.ScaleType {
    return GEnum.ScaleType.SchoolClass;
  }

  get scaleTypeSchool(): GEnum.ScaleType {
    return GEnum.ScaleType.School;
  }

  async fetchStudentCompetencyDistributions() {
    switch (this.scaleType) {
      case GEnum.ScaleType.SchoolClass:
        this.targetType = GEnum.TargetType.Class;
        this.targetID = this.student.schoolClass.schoolClassID;
        break;
      case GEnum.ScaleType.Grade:
        this.targetType = GEnum.TargetType.Grade;
        this.targetID = this.student.schoolClass.grade;
        break;
      case GEnum.ScaleType.School:
        this.targetType = 0;
        this.targetID = 0;
        break;
    }

    return studentAllCompetencyModule.fetchStudentCompetencyDistributions({
      studentID: this.student.studentID,
      targetType: this.targetType,
      targetID: this.targetID,
    } as CompetencyDistributionRequest);
  }

  handleChangeScaleType() {
    this.lazy = false;
    this.fetchStudentCompetencyDistributions().then(() => {
      setTimeout(() => {
        this.lazy = true;
        this.updateChart();
      }, 1);
    });
  }

  updateChart() {
    this.competencyDistributionCharts = this.studentCompetencyDistributions.reduce((result: CompetencyDistributionEchartService[], competencyDistribution: StudentCompetencyDistribution) => {
      const chartService: CompetencyDistributionEchartService = new CompetencyDistributionEchartService(
        this.CHART_HEIGHT,
        competencyDistribution.target,
        competencyDistribution.organization,
        competencyDistribution.isExistScore
      );
      result.push(chartService);
      return result;
    }, []);
  }
}
